import {Component, Input, OnInit} from '@angular/core';
import {GeneralSymbolsEncodingComponent} from '../general-symbol-encoding/g-symbols-encoding.component';

@Component({
  selector: 'app-symbols-encoding-random',
  templateUrl: '../general-symbol-encoding/symbols-encoding-image.component.html',
  styleUrls: ['../general-symbol-encoding/symbols-encoding-image.component.css']
})
export class SymbolsEncodingRandomComponent extends GeneralSymbolsEncodingComponent {

  @Input() numberOfEncodings: number;
  @Input() inputEncodings: number[][];
  @Input() isHorizontalView: boolean;

  generateRandomExercise() {
    if (this.inputEncodings === undefined) {
      this.initValues();

      const numberOfEncodings = this.getNumberOfEncodings();
      const lengthOfEncoding = this.getEncodingLength();

      this.generateAllEncodings(lengthOfEncoding);

      this.generateCoding(numberOfEncodings);
      this.encodings = this.generalEncoding;
      this.currentEncodingChange.emit(this.encodings);
    } else {
      this.encodings = this.inputEncodings;
      this.currentEncodingChange.emit(this.encodings);
    }
  }

  getEncodingLength() {
    if (this.level !== 3) {
      return 3;
    } else {
      return 4;
    }
  }

  getNumberOfEncodings() {
    return this.numberOfEncodings;
  }

}
